import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import api from "../lib/api";
import { ProductCard } from "../components/ProductCard";

const CATS = [
  { key: "all", label: "All" },
  { key: "monster-shirts", label: "Monster Shirts" },
  { key: "shirts", label: "Shirts" },
  { key: "hoodies", label: "Hoodies" },
  { key: "stickers", label: "Stickers" },
  { key: "accessories", label: "Accessories" },
];

export default function Shop() {
  const [params, setParams] = useSearchParams();
  const category = params.get("category") || "all";
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    api.get("/products", { params: category !== "all" ? { category } : {} })
      .then((r) => setProducts(r.data))
      .finally(() => setLoading(false));
  }, [category]);

  return (
    <div className="max-w-[1400px] mx-auto px-6 py-12" data-testid="shop-page">
      <h1 className="font-display text-5xl sm:text-6xl uppercase tracking-tighter mb-2">The <span className="text-[#FF3B30]">Store</span></h1>
      <p className="text-zinc-400 text-sm mb-8">{products.length} products</p>

      <div className="flex flex-wrap gap-3 mb-10 border-b border-zinc-800 pb-6">
        {CATS.map((c) => (
          <button key={c.key} data-testid={`filter-${c.key}`}
            onClick={() => setParams(c.key === "all" ? {} : { category: c.key })}
            className={`px-5 py-2.5 text-xs font-bold uppercase tracking-widest border transition-colors duration-200 ${category === c.key ? "bg-[#FF3B30] border-[#FF3B30] text-white" : "border-zinc-700 text-zinc-400 hover:border-white hover:text-white"}`}>
            {c.label}
          </button>
        ))}
      </div>

      {loading ? (
        <div className="text-zinc-500 py-20 text-center">Loading gear…</div>
      ) : products.length === 0 ? (
        <div className="text-zinc-500 py-20 text-center">No products in this category yet.</div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8" data-testid="product-grid">
          {products.map((p, i) => <ProductCard key={p.id} product={p} index={i} />)}
        </div>
      )}
    </div>
  );
}
